<template>
    <div v-if="data">
        <div class="overlay" @click="closePopup"  :class="{'show': openQuickDiamondView}"></div>
        <div class="bottom-sheet quick-view-container" :class="{'show':openQuickDiamondView}">
            <div class="quick-view">
                <div class="steps_close">
                    <SvgHeaderSvg class="largesvg" @click="closePopup" :type="'close'" />
                </div>

                <div class="quick-view-content">
                    <div class="images-container">
                        
                        <CyoLooseQuickViewDiamondImageSlider 
                        :images="{
                            diamond_image: data?.thumb_image_one,
                            diamond_image_two: data.thumb_image_two,
                            json_video: data.video_one,
                            json_video_two: data.video_two,
                        }"
                        :data="data"
                        />
                        <!-- :is_supplier_stone="data?.is_supplier_stone" -->
                        
                    </div>
                    <h4 class="title font-active">{{ data.title }}</h4>
    
                    <h5 class="text-center price">
                        {{ $formatPrice(data.price_total) }}
                    </h5>

                    <div class="diam-details">
                        <p class="title_mod">Diamond1 : &nbsp;<span class="value">{{data.lot_one}}</span></p>
                        <div class="d-flex justify-content-between">
                            <div class="flex"> 
                                <p class="value">{{ data.carat_one }} Ct</p>
                                <p class="text">Carat</p>
                            </div>
                            <div class="flex  text-uppercase">
                                <p class="value">{{ data.color_one }}</p>
                                <p class="text">Color</p>
                            </div>
                            <div class="flex ">
                                <p class="value">{{ data.cut_grade_one }}</p>
                                <p class="text">Cut</p>
                            </div>
                            <div class="flex ">
                                <p class="value">{{ data.clarity_one }} </p>
                                <p class="text">Clarity</p>
                            </div>
                            <div class="flex  text-uppercase border-0">
                                <p class="value">{{ data.report_one }}</p>
                                <p class="text">Lab</p>
                            </div>
                        </div>
                    </div>
                    <div class="diam-details">

                        <p class="title_mod">Diamond2 : &nbsp;<span class="value">{{data.lot_two}}</span></p>
                        <div class="d-flex justify-content-between">
                            <div class="flex"> 
                                <p class="value">{{ data.carat_two }} Ct</p>
                                <p class="text">Carat</p>
                            </div>
                            <div class="flex  text-uppercase">
                                <p class="value">{{ data.color_two }}</p>
                                <p class="text">Color</p>
                            </div>
                            <div class="flex ">
                                <p class="value">{{ data.cut_grade_two }}</p>
                                <p class="text">Cut</p>
                            </div>
                            <div class="flex ">
                                <p class="value">{{ data.clarity_two }} </p>
                                <p class="text">Clarity</p>
                            </div>
                            <div class="flex  text-uppercase border-0">
                                <p class="value">{{ data.report_two }}</p>
                                <p class="text">Lab</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex gap-2 btn-container">
                        <button class="cta_btn details-btn" @click="$emit('openDetailsPage',data.slug)">DETAILS</button>
                        <button v-if="!showLoader" class="cta_btn diamond-btn" @click="chooseDiamond()">CHOOSE THIS Diamond</button>
                        <button v-else class="cta_btn diamond-btn">PLEASE WAIT...</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { cyoStore }  from '@/stores/cyo/cyo';
    import { cyodetailStore }  from '@/stores/cyodetail/cyodetail';

    const {$formatPrice,$selectdiamondGtag} = useNuxtApp()
    const localePath = useLocalePath()
    const route = useRoute()
    const router = useRouter()

    const props = defineProps(['data','openQuickDiamondView'])
    const emits = defineEmits(['closeDiamondQuickView','openDetailsPage'])

    const moduleType = route.meta.moduleType
    const moduleSubType = route.meta.moduleSubType

    const storeCyo = cyoStore();
    const store = cyodetailStore();

    const showLoader = ref(false)

    function closePopup(){
        emits('closeDiamondQuickView')
    }

   
    const item = computed(() => {
        const item = store.getDiamondDetail()
        return item
    })

    const chooseDiamond = ()=>{
        selectDiamond()
        closePopup()
    }

    const selectDiamond = async ()=> {
        const settings = {moduleType: moduleType ,moduleSubType: moduleSubType , slug: props.data.slug }
        await store.setDiamondForDetailPage( settings)

        // emits('productUrl', type)

        showLoader.value = true
        let modifiedModuleSubType

        if(moduleSubType === 'ring'){
            modifiedModuleSubType = 'ring'
        }
        else if(moduleSubType === 'pendant'){
            modifiedModuleSubType = 'pendant'
        }
        else{
            modifiedModuleSubType = moduleSubType
        }

        
        console.log(modifiedModuleSubType,'modifiedModuleSubType')

      

        const isCompatible = storeCyo.checkCompatibility(  { moduleSubType: modifiedModuleSubType,  page: 'diamond' } )

        if(!isCompatible){
            alert('The diamond and the product setting you have selected are not compatible.')
            return
        }

        await storeCyo.setDiamond({ item: {...item.value}, moduleSubType: modifiedModuleSubType } )
        $selectdiamondGtag(modifiedModuleSubType);

        const diamond = storeCyo.getDiamond(modifiedModuleSubType)
        const setting = storeCyo.getSetting(modifiedModuleSubType)

        if (diamond && setting) {
            return router.push( localePath( {name: 'cyo-complete-'+modifiedModuleSubType, query:{ sid: setting.metal.id, did: diamond.id }}) ); 
        }
        
        showLoader.value = false
        return router.push( localePath( {name: 'cyo-setting-list-'+modifiedModuleSubType} ) ); 

    }


    onBeforeUnmount(()=>{
       closePopup()
    })


</script>

<style scoped>

.overlay{
    position: fixed;
    left: 0;
    bottom: -100%;
    height: 0;
    width: 100%;
    background: #00000063;
    z-index: 99;
    transition: 0.1s;
    pointer-events: auto;
}

.overlay.show{
    bottom: 0;
    height: 100%;
    transition-delay: 0.1s;
}

.bottom-sheet{
    position: fixed;
    bottom: -200px;
    left: 0;
    height: 0;
    width: 100%;
    background-color: #fff;
    transition: 1s;
    z-index: 100;
}

.bottom-sheet.show{
    height: 590px;
    max-height: 90vh;
    bottom: 0;
    transition: 0.6s;

}


.quick-view-container {
    padding: 12px;
    border-radius: 8px 8px 0 0;
    background: #fff;
    width: 100%;
    overflow: auto;
}

.images-container{
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.diam-details{
    margin: 30px auto;
    max-width: 500px;
    width: 100%;
}

.flex{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #eaeaea;
    flex: 1;
}

.flex p{
    margin: 0;
}

.flex .text{
    font-size: 12px;
    text-transform: uppercase;
    color: #606060;
}

.flex .value{
    font-weight: bold;
    font-size: 16px;
    color: #353535;
}

h4.title {
    font-size: 18px;
    color: #212529;
    text-align: center;
    text-transform: capitalize;
}

h5.price {
    font-size: 18px;
    color: var(--green);
    font-weight: 600;
    margin-top: 16px;
}

.metals-box{
    margin: 32px auto;
}

.btn-container{
    max-width: 360px;
    margin:auto;
}

.cta_btn {
    border: 1px solid var(--green);
    text-align: center;
    border-radius: 4px;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1.12px;
    padding: 12px 16px;
    /* min-width: 100px; */
}

.cta_btn.details-btn{
    color: var(--green);
    background-color: #fff;
    min-width: 100px;
}

.cta_btn.diamond-btn{
    margin-left: 12px;
    padding: 12px;
    color: #fff;
    background-color: var(--green);
    width: 100%;
}

.steps_close {
    text-align: right;
    margin-bottom: 5px;

}

.largesvg {
    transform: scale(1.3);
}
</style>